/**
 * Presence command carrying the local participant's camera view zoom, so
 * others can show the same framing of that camera.
 */
export const CAMERA_ZOOM_SYNC_COMMAND = 'camera-zoom';

/**
 * Presence command carrying the local participant's screenshare view zoom.
 */
export const SCREENSHARE_ZOOM_SYNC_COMMAND = 'screenshare-zoom';

/**
 * Minimum time between two presence updates for the same video while the
 * zoom keeps changing (wheel, drag). The final state is always sent.
 */
export const ZOOM_SYNC_SEND_INTERVAL_MS = 150;

/**
 * Below this the view counts as not zoomed and the video is shown as-is.
 */
export const ZOOM_SYNC_EPSILON = 0.001;

/**
 * Zoom a double click / double tap applies to the large video. Kept at the
 * historical maximum of the view zoom while the buttons may go further.
 */
export const DOUBLE_CLICK_VIEW_ZOOM = 5;
